/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsListReportDefinitionQueryResponse, AuditReportsListReportDefinitionQueryParams, AuditReportsListReportDefinition401, AuditReportsListReportDefinition403 } from "../models/AuditReportsListReportDefinition";

export function getAuditReportsListReportDefinitionUrl() {
  const res = { method: 'GET', url: `/audit-reports/v1/report-definitions` as const }
  return res
}

/**
 * @description Returns all report definitions for the client, optionally filtered by report type
 * @summary List all report definitions
 * {@link /audit-reports/v1/report-definitions}
 */
export async function auditReportsListReportDefinition(params?: AuditReportsListReportDefinitionQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsListReportDefinitionQueryResponse, ResponseErrorConfig<AuditReportsListReportDefinition401 | AuditReportsListReportDefinition403>, unknown>({ method : "GET", url : getAuditReportsListReportDefinitionUrl().url.toString(), params, ... requestConfig })
  return res.data
}